<template>
  <div style="margin: 0 auto;">

    <div style="padding: 16px;">
      <!-- 頭部 -->
      <div class="header">

        <h2 class="title">餘額記錄</h2>
      </div>

      <div style="position: fixed; top: 30px; left: 30px;">
        <el-button icon="el-icon-arrow-left" @click="close" class="back-btn" plain size="small">
        </el-button>
      </div>

      <div>
        <div style="margin-top: 10px; padding: 10px;">
          <el-form :model="formInline" class="demo-form-inline">
            <div style="width: 100%;">
              <el-form-item label="開始時間">
                <el-date-picker value-format="timestamp" v-model="formInline.dates1" type="date" placeholder="開始日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="結束時間" style="width: 100%;">
                <el-date-picker value-format="timestamp" v-model="formInline.dates2" type="date" placeholder="結束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="變動類型">
                <el-radio v-model="formInline.type" label="">全部</el-radio>
                <el-radio v-model="formInline.type" label="0">充值</el-radio>
                <el-radio v-model="formInline.type" label="1">消費</el-radio>
              </el-form-item>
              <el-form-item>
                <div @click="onSubmit"
                  style="text-align: center; padding: 2px 0; text-align: center; background-color: #3E4F7A; color: white; border-radius: 100px;">
                  查詢
                </div>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>

      <div v-if="records.length > 0">
        <div style="">
          <div v-for="(record, index) in records" :key="index"
            style="width: 92%; padding: 10px 16px 10px 10px; border-bottom: 1px #efefef solid;">
            <div style="display: flex; justify-content: space-between; margin: 6px 0px;">
              <div style="width: 70%; font-size: 16px; color: #3E4F7A; font-weight: 600;">{{ record.balance_log.reason }}</div>
              <div style="width: 24%; text-align: right; font-size: 18px; font-weight: bold;"
                :style="record.balance_log.type === 1 ? 'color: #C43826' : 'color: #4F9346'">{{ record.balance_log.type === 0 ? '+' : '-'
                }} {{ record.balance_log.money }}</div>
            </div>
            <div
              style="display: flex; justify-content: space-between; color: #9f9d9d; font-size: 14px; margin-bottom: 6px;">
              <div style="">{{ formatTime(record.balance_log.create_at * 1000) }}</div>

              <div style="text-align: right; font-size: 14px;">餘額 {{ Number(record.balance_log.total_money / 100).toFixed(2) }} HKD
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="records.length <= 0" style="flex: 1; display: flex; justify-content: center; align-items: center;">
        <el-empty description="當前類型暫無數據"></el-empty>
      </div>
    </div>

    <div style="margin-bottom: 60px;">
      <!-- 分頁控件 -->
      <div style="display: flex; justify-content: center; align-items: center; gap: 12px; margin-top: 24px;">
        <button @click="goFirst" :disabled="currentPage === 1" :style="paginationButtonStyle">
          ⏮️ 首頁
        </button>
        <button @click="prevPage" :disabled="currentPage === 1" :style="paginationButtonStyle">
          ◀️ 上一頁
        </button>
        <div style="padding: 8px 16px; background: #f6f8fb; border-radius: 6px;
                color: #666; font-size: 14px;">
          第 {{ currentPage }} 頁
        </div>
        <button @click="nextPage" :disabled="currentPage === totalPages" :style="paginationButtonStyle">
          ▶️ 下一頁
        </button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      currentPage: 1,
      totalPages: 6, // 總頁數示例
      records: [],
      // user: JSON.parse(localStorage.getItem("LOGINED")),
      formInline: {
        dates1: "",
        dates2: "",
        type: ''
      }
    }
  },
  mounted() {
    // 獲取記錄
    this.GETBalanceRecordInfoList()
  },
  computed: {
    paginationButtonStyle() {
      return {
        padding: '8px 16px',
        background: '#F6F8FB',
        border: '1px solid #E0E0E0',
        borderRadius: '6px',
        cursor: 'pointer',
        color: '#666',
        opacity: this.disabled ? '0.6' : '1',
        filter: this.disabled ? 'grayscale(0.8)' : 'none'
      }
    },
  },
  methods: {
    GETBalanceRecordInfoList() {
      var d = this.formInline
      this.$axios.get(`/api/balanceRecord/list?page=${this.currentPage}&perPage=${6}&start=${(d.dates1 / 1000) || ''}&end=${(d.dates2 / 1000) || ''}&status=${d.type}`).then(res => {
        var d = res.data.data

        this.records = d.items
        this.totalPages = Math.ceil(d.total / 6)

        if (this.currentPage > this.totalPages) {
          this.currentPage = this.totalPages
          this.GETBalanceRecordInfoList()
        }
      })
    },
    formatBalance(value) {
      return (value / 1e6).toLocaleString('en-US', {
        minimumFractionDigits: 6,
        maximumFractionDigits: 6
      })
    },
    onSubmit() {
      this.GETBalanceRecordInfoList()
    },
    close() {
      // 關閉邏輯
      this.$router.go(-1)
    },
    formatTime(timestamp) {
      const date = new Date(timestamp)
      return `${date.toLocaleDateString()} ${date.toLocaleTimeString('zh-CN', { hour12: false })}`
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--
      this.GETBalanceRecordInfoList()
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++
      this.GETBalanceRecordInfoList()
    },
    goFirst() {
      this.currentPage = 1
      this.GETBalanceRecordInfoList()
    },
  },

}
</script>

<style>
.header {
  display: flex;
  align-items: center;
  padding: 16px 0;
  margin-bottom: 20px;
}

.back-btn {
  padding: 12px !important;
  border-radius: 8px;
}

.title {
  flex: 1;
  text-align: center;
  color: #3E4F7A;
  margin: 0;
  font-size: 18px;
}

.el-input__prefix {
  display: none !important;
}
</style>
